import styled from 'styled-components';
import Heading from 'styles/typography/Heading';
import { breakpoint } from 'styles/globals';
import { type Theme, getBodyStyle, getColor } from 'styles/theme';

export const Wrapper = styled.div`
  @media (${breakpoint.lgMin}) {
    display: flex;
    align-items: center;
  }

  @media (${breakpoint.xlMin}) {
    gap: 40px
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0 0 16px;
  flex: 1;

  @media (${breakpoint.mdMin}) {
    padding: 0 0 16px;
  }

  &.has-featured-media {
    @media (${breakpoint.lgMin}) {
      padding: 0 98px;
    }
    @media (${breakpoint.xlMin}) {
      padding: 0 134px;
    }
  }
`;

export const PaidContentAndLogo = styled.div`
  .separator {
    margin-top: 8px;
  }
`;

export const SocialLinksInHeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 8px;

  .byline-dropdown {
    margin-top: -8px;
  }
`;

export const HeadingTitle = styled(Heading)``;
export const Description = styled.p<{ theme: Theme }>`
  ${getBodyStyle('graphikCompact', { default: 'default' }, 'regular')};
  font-style: italic;
`;

export const ImageContainer = styled.div`
  flex: 1;
  width: 100vw;
  margin-left: calc((100% - 100vw) / 2);

  @media (${breakpoint.lgMin}) {
    width: unset;
    margin-left: unset;
  }
`;

export const FeaturedMediaContainer = styled.div`
  width: 100vw;
  margin-left: calc((100% - 100vw) / 2);

  @media (${breakpoint.xlMin}) {
    max-width: 1184px;
    margin-left: calc((100% - 1184px) / 2)

  }
`;

export const Source = styled.span<{ theme: Theme }>`
  display: block;
  padding: 4px 0 0 20px;
  ${getBodyStyle('graphikCompact', { default: 'small' }, 'regular')};
  font-style: italic;

  @media (${breakpoint.lgMin}) {
    padding: 0;
  }
`;

export const ShareButtonWrapper = styled.div<{ theme: Theme }>`
  .hero-share-button {
    display: flex;
    align-items: center;
    gap: 8px;
    ${getBodyStyle('graphikCompact', { default: 'default' }, 'medium')};
    text-decoration: none;
    box-shadow: 4px 4px 20px 0px ${getColor('neutralBlack')}0d;
    text-transform: unset;
    max-width: 200px;
    padding: 0px 16px;
  }

  .social-dropdown-button {
    width: 24px;
    height: 24px;
    margin-top: 8px;
  }
`;

export const Byline = styled.div<{ theme: Theme }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const ByLineWithoutAuthors = styled.div<{ theme: Theme }>`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 8px;
`;

export const Author = styled.span`
  font-weight: 600;
`;
